export default "__VITE_ASSET__DxyqMxx5__"